import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const RejectReasonFilter = ({ rejectReasons = [], value = [], onChange }) => {
  const { t } = useTranslation()

  return (
    <div>
      <ComboBox
        menuItems={rejectReasons?.map(r => ({ label: t(r.label), value: r.value }))}
        value={value || []}
        multiple
        fullWidth
        label={t('Motivo de rechazo')}
        handleChange={e => onChange(e.target.value)}
      />
    </div>
  )
}

export default RejectReasonFilter
